export const INBOX = {};
INBOX.INBOX_MODAL_TOGGLE = "INBOX_MODAL_TOGGLE";
INBOX.INBOX_BADGE_UPDATE = "INBOX_BADGE_UPDATE";
INBOX.MEMBER_MODAL_TOGGLE = "MEMBER_MODAL_TOGGLE";
INBOX.UPDATE_POST_DETAILS = "UPDATE_POST_DETAILS";
